import React, { useEffect, useState } from 'react';
import './FolderAction.css';
import { MdKeyboardBackspace } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { FaFolderMinus } from 'react-icons/fa6';
import { Button, Card, Drawer, Select, Table, Pagination, Modal } from 'antd';
import { IoIosInformationCircle, IoMdAdd } from 'react-icons/io';
import { FaRegBookmark } from 'react-icons/fa';
import { HiOutlineDotsVertical } from 'react-icons/hi';
import AddActionDrawer from '../AddActionDrawer/AddActionDrawer';
import CardSkeleton from '../../../../../Components/Skeleton/CardSkeloton';
import { workspaces_Quick_Action_ListHandler } from '../../../../../Redux/Actions/user/WorkspaceQuickList';
import { IoBookmark, IoBookmarkOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { workspaces_Bookmark_Toggle_ActionHandler } from '../../../../../Redux/Actions/user/WorkspaceBookmarkToggle';
import { Quick_Action_Delete_Handler } from '../../../../../Redux/Actions/user/QuickActionDelete';
import Swal from 'sweetalert2';
import authAxios from '../../../../../Config/AuthAxios';
import { BASEURL } from '../../../../../config';
import { workspaces_FolderList_ActionHandler } from '../../../../../Redux/Actions/user/WorkspaceSupportingDocumentList';
const curveImg = '/assets/CurveImage.svg';
const Linear_equal = '/assets/linearEqual.svg';
const SearchIcon = '/assets/SearchIcon.svg';
const SucessTaskIcon = '/assets/Linear-task.svg';
const FourBoxIcon = '/assets/Linear-four-Box.svg';
let { Option } = Select;

const FolderAction = ({
    setViewActionWorkspace,
    setViewActionWorkspaceid,
    workspace_id,
    setworkspacefoldername,
    handleViewActionWorkspaceClick,
    permissionsDetails,
    handleViewActionWorkspaceClickBack,
    workspaceRole = '',
}) => {
    let Navigate = useNavigate();
    let dispatch = useDispatch();
    const [sortedInfo, setSortedInfo] = useState(null);
    const [isStandardOpen, setIsStandardOpen] = useState(false);
    const [itemToggleState, setItemToggleState] = useState({});
    const [isToggleAction, setToggleAction] = useState({});
    const [searchValue, setSearchValue] = useState(null);
    const [isView, setIsView] = useState('listView');
    const [modal2Open, setModal2Open] = useState(false);
    const [permissionModalOpen, setPermissionModalOpen] = useState(false);
    const [quickActionCreatedByName, setQuickActionCreatedByName] =
        useState('');

    const itemsPerPage = 7;
    const [currentPage, setCurrentPage] = useState(1);
    const indexOfLastItem = currentPage * itemsPerPage;

    useEffect(() => {
        dispatch(
            workspaces_Quick_Action_ListHandler(
                workspace_id,
                setViewActionWorkspaceid,
                '',
                '',
                currentPage
            )
        );
    }, []);
    const workspaceQuickactionsListData = useSelector(
        (state) =>
            state?.workspaces_QuickList_Data.workspace_quickactionsList_data
                ?.data
    );
    const QauserData = useSelector(
        (state) => state.SettingsUserProfileData?.user_profile_data
    );

    const [isOwner, setIsOwner] = useState(false);
    useEffect(() => {
        if (
            (QauserData?.id &&
                QauserData?.role_name != undefined &&
                QauserData?.role_name != null) ||
            (workspaceRole != '' &&
                workspaceRole != null &&
                workspaceRole != undefined)
        ) {
            if (
                QauserData?.role_name?.toLowerCase().includes('owner') ||
                workspaceRole?.toLowerCase().includes('owner')
            ) {
                setIsOwner(true);
            }
        }
    }, [QauserData]);

    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems =
        workspaceQuickactionsListData?.data.slice(
            indexOfFirstItem,
            indexOfLastItem
        ) || [];
    const bookmarkedDetails = useSelector(
        (state) =>
            state?.WorkspaceBookmarkToggleData?.workspace_bookmark_toggle_data
    );

    const DeleteQuickaction = useSelector(
        (state) => state?.QuickActionDeleteData?.quick_action_delete_data
    );
    useEffect(() => {
        if (DeleteQuickaction?.message) {
            dispatch(
                workspaces_Quick_Action_ListHandler(
                    workspace_id,
                    setViewActionWorkspaceid,
                    '',
                    '',
                    currentPage
                )
            );
        }
    }, [DeleteQuickaction]);

    useEffect(() => {
        if (bookmarkedDetails) {
        }
    }, [bookmarkedDetails]);

    const handleOnEdit = (id) => {
        Navigate(`/edit-quick-action/${id}`);
    };

    const handleOnAction = (id) => {
        Navigate(`/workspaces/runQuickAction/${id}`);
    };

    const handleToggleBookmark = (qaId) => {
        dispatch(workspaces_Bookmark_Toggle_ActionHandler(qaId));
    };

    const columns = [
        {
            title: 'QuickAction Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => a.name - b.name,
        },
        {
            title: 'Folder Name',
            dataIndex: 'folder_name',
            key: 'folder_name',
            sorter: (a, b) => a.folder_name - b.folder_name,
        },
        {
            title: 'Add Bookmark',
            dataIndex: 'is_user_bookmarked',
            key: 'is_user_bookmarked',
            sorter: (a, b) => a?.is_user_bookmarked - b?.is_user_bookmarked,
            width: 150,
            render: (text, record) => (
                <>
                    <div className='workspaces-user-bookmarked-center'>
                        {record.is_user_bookmarked ? (
                            <IoBookmark
                                className='workspaces-user-bookmarked-bg workspaces-user-bookmarked-hw'
                                onClick={() => handleToggleBookmark(record?.id)}
                            />
                        ) : (
                            <IoBookmarkOutline
                                className='workspaces-user-bookmarked-hw'
                                onClick={() => handleToggleBookmark(record?.id)}
                            />
                        )}
                    </div>
                </>
            ),
        },
        // {
        //     title: 'Restricted',
        //     dataIndex: 'restricted',
        //     key: 'restricted',
        //     sorter: (a, b) => a.is_restricted - b.is_restricted,
        //     render: (_, item, index) => (
        //         <div
        //             className='workspace-build-restricted'
        //             onClick={() => {
        //                 if (!isOwner) {
        //                     setPermissionModalOpen(true);
        //                 } else {
        //                     if (item?.is_restricted) {
        //                         LockQuickAction_Api(
        //                             { quickaction_id: item?.id, action: false },
        //                             item?.is_restricted
        //                         );
        //                     } else {
        //                         LockQuickAction_Api(
        //                             { quickaction_id: item?.id, action: true },
        //                             item?.is_restricted
        //                         );
        //                     }
        //                 }
        //             }}>
        //             {item?.is_restricted ? (
        //                 <img src='/assets/lockBuild.svg' alt='lock' />
        //             ) : (
        //                 <img src='/assets/notLockBuild.svg' alt='no-lock' />
        //             )}
        //         </div>
        //     ),
        // },
        {
            title: 'Action',
            dataIndex: '',
            key: 'x',
            render: (text, record) => (
                <>
                    <label
                        className='workspaces-user-action-button'
                        onClick={() => {
                            Navigate(
                                `/workspaces/runQuickAction/${record?.id}`
                            );
                        }}>
                        Action
                    </label>
                    <label className='ml-5-mr-5'>|</label>
                    <label
                        className='workspaces-user-action-button'
                        onClick={() => {
                            if (record?.is_copied && record?.is_custom) {
                                setPermissionModalOpen(true);
                            } else if (!record?.is_restricted) {
                                Navigate(`/edit-quick-action/${record?.id}`);
                            } else {
                                if (
                                    JSON.parse(
                                        localStorage.getItem('userDetails')
                                    )?.id === record?.created_by
                                ) {
                                    Navigate(
                                        `/edit-quick-action/${record?.id}`
                                    );
                                } else {
                                    setQuickActionCreatedByName(
                                        record?.created_by_name
                                    );
                                    setModal2Open(true);
                                }
                            }
                        }}>
                        Edit
                    </label>
                    <label className='ml-5-mr-5'>|</label>
                    {permissionsDetails?.includes('create-delete-qa') ? (
                        <label
                            className={'workspaces-user-action-button'}
                            onClick={() => {
                                if (!record?.is_restricted) {
                                    handleDelete(record?.id);
                                } else {
                                    if (
                                        JSON.parse(
                                            localStorage.getItem('userDetails')
                                        )?.id === record?.created_by
                                    ) {
                                        handleDelete(record?.id);
                                    } else {
                                        setQuickActionCreatedByName(
                                            record?.created_by_name
                                        );
                                        setModal2Open(true);
                                    }
                                }
                            }}>
                            Delete
                        </label>
                    ) : (
                        <label
                            className={
                                'workspaces-user-action-button permision-not-allowed-css'
                            }>
                            Delete
                        </label>
                    )}
                </>
            ),
        },
    ];

    const handleDelete = (Id) => {
        if (Id) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'You want to delete this QuickAction?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        position: 'centre',
                        icon: 'success',
                        title: 'QuickAction has been deleted successfully',
                        showConfirmButton: false,
                        timer: 1000,
                    });
                    dispatch(Quick_Action_Delete_Handler(Id));
                }
            });
        }
    };

    const StandardOverlay = () => {
        setIsStandardOpen(!isStandardOpen);
    };
    const handleChnageView = (values) => {
        setIsView(values);
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        dispatch(
            workspaces_Quick_Action_ListHandler(
                workspace_id,
                setViewActionWorkspaceid,
                '',
                '',
                page
            )
        );
    };
    const debounce = (func, delay) => {
        let timeoutId;
        return function (...args) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };

    const handleSearch = debounce((e) => {
        let value = e.target.value;
        let encodedValue = encodeURIComponent(value);
        if (encodedValue?.length) {
            setSearchValue(encodedValue);
        }
        if (!encodedValue.length) {
            dispatch(
                workspaces_Quick_Action_ListHandler(
                    workspace_id,
                    setViewActionWorkspaceid,
                    '',
                    '',
                    ''
                )
            );
        }
    }, 1000);
    useEffect(() => {
        if (searchValue?.length > 3) {
            dispatch(
                workspaces_Quick_Action_ListHandler(
                    workspace_id,
                    setViewActionWorkspaceid,
                    searchValue,
                    '',
                    ''
                )
            );
        }
    }, [searchValue]);

    const handleSortChange = (sortvalue) => {
        dispatch(
            workspaces_Quick_Action_ListHandler(
                workspace_id,
                setViewActionWorkspaceid,
                '',
                sortvalue,
                ''
            )
        );
    };
    const handleToggleAction = (itemId) => {
        setItemToggleState((prevToggleState) => {
            const newState = { ...prevToggleState };
            newState[itemId] = !newState[itemId];
            newState[isToggleAction] = !newState[isToggleAction];
            return newState;
        });
    };
    // const handleToggleAction = (itemId) => {
    //   setItemToggleState((prevToggleState) => ({
    //     ...prevToggleState,
    //     [itemId]: !prevToggleState[itemId],
    //     [isToggleAction]: !prevToggleState[isToggleAction],
    //   }));
    // };
    const handleBuildNavigation = () => {
        let navigateObj = {
            workspaceId: workspace_id,
            folderId: setViewActionWorkspaceid,
        };

        navigateObj = Object.fromEntries(
            Object.entries(navigateObj).filter(([_, value]) => value != null)
        );

        const queryParams = new URLSearchParams(navigateObj).toString();
        const navigateUrl = `/build-quick-action${
            queryParams ? `?${queryParams}` : ''
        }`;

        Navigate(navigateUrl);

        //gtm
        window.dataLayer.push({
            event: 'Add QuickAction',
            buttonName: 'Add QuickAction',
            userId: JSON.parse(localStorage.getItem('userDetails'))?.id,
            clientId: JSON.parse(localStorage.getItem('userDetails'))
                ?.client_id,
        });
    };

    const LockQuickAction_Api = async (data, isres) => {
        try {
            const token = localStorage.getItem('token');
            const res = await authAxios({
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                method: 'POST',
                url: BASEURL + `quick-action/lock`,
                data: JSON.stringify(data),
            });
            if (res?.status === 200) {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: `Quick action ${
                        isres ? 'unlocked' : 'locked'
                    } succesfully`,
                    showConfirmButton: false,
                    timer: 1500,
                });
                dispatch(
                    workspaces_Quick_Action_ListHandler(
                        workspace_id,
                        setViewActionWorkspaceid,
                        '',
                        '',
                        currentPage
                    )
                );
            }
        } catch (err) {
            return err;
        }
    };

    return (
        <div className='folderAction-div'>
            <div className='folder-action-main-1'>
                <h3>
                    <FaFolderMinus />
                    {setworkspacefoldername} (
                    {workspaceQuickactionsListData?.total || 0})
                </h3>
                <div>
                    {/* <h4 onClick={() => setViewActionWorkspace(false)}>
            View Other Folders
          </h4> */}
                    <h4
                        onClick={() =>
                            handleViewActionWorkspaceClickBack(false)
                        }>
                        <MdKeyboardBackspace />
                        Back to Folder
                    </h4>
                    {/* <Button className='main-api' onClick={StandardOverlay}>
                        <IoMdAdd />
                        Add QuickActions
                    </Button> */}
                </div>
            </div>

            <div className='workspace-action-table-2'>
                <div className='relative search-container'>
                    <input
                        type='text'
                        placeholder='Search here...'
                        className='search-from-logs'
                        onChange={(e) => handleSearch(e)}
                    />
                    <img src={SearchIcon} alt='' className='search-icon' />
                </div>
                <div className='workspace-action-table-inner-2'>
                    {permissionsDetails?.includes('create-delete-qa') ? (
                        <Button
                            className='main-api '
                            onClick={handleBuildNavigation}>
                            <IoMdAdd />
                            Add QuickActions
                        </Button>
                    ) : (
                        <Button className='main-api permision-not-allowed-css'>
                            <IoMdAdd />
                            Add QuickActions
                        </Button>
                    )}

                    <div
                        className={
                            isView === 'listView' ? 'active-list-bg' : null
                        }
                        onClick={() => handleChnageView('listView')}>
                        <img src={SucessTaskIcon} alt='' />
                    </div>
                    <div
                        className={
                            isView === 'gridView' ? 'active-list-bg' : null
                        }
                        onClick={() => handleChnageView('gridView')}>
                        <img src={FourBoxIcon} alt='' />
                    </div>
                    <Select
                        defaultValue='Sort By'
                        style={{ width: 120, height: '36px' }}
                        onChange={handleSortChange}>
                        <Option value='name'> Name</Option>
                        <Option value='created_at'> Created At</Option>
                    </Select>
                </div>
            </div>
            <div className='folder-action-main-2'>
                {isView === 'listView' ? (
                    <>
                        <Table
                            columns={columns}
                            dataSource={workspaceQuickactionsListData?.data}
                            bordered
                            size='middle'
                            pagination={{
                                pageSize:
                                    workspaceQuickactionsListData?.per_page,
                                total: workspaceQuickactionsListData?.total,
                                showSizeChanger: false,
                                onChange: handlePageChange,
                            }}
                            className={`mytable mytable-sorter ${
                                sortedInfo ? 'sorted' : ''
                            }`}
                            onChange={(pagination, filters, sorter) =>
                                setSortedInfo(sorter)
                            }
                        />
                    </>
                ) : (
                    <>
                        <Card bordered={false} className='curve_card-folder'>
                            {workspaceQuickactionsListData?.total > 0 ? (
                                <>
                                    <div className='folder-grid-container'>
                                        {workspaceQuickactionsListData?.data.map(
                                            (item, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        position: 'relative',
                                                    }}>
                                                    <img
                                                        src={curveImg}
                                                        alt=''
                                                        className='curve-image-folder'
                                                    />
                                                    <img
                                                        src={Linear_equal}
                                                        alt=''
                                                        className='curve-linerequal-img-folder'
                                                    />
                                                    <div className='curve-linear-icons-folder recent-div-action'>
                                                        {/* <IoIosInformationCircle /> */}
                                                        <div className='recent-div-action'>
                                                            <IoIosInformationCircle />
                                                        </div>
                                                        {/* <FaRegBookmark onClick={() => handleToggleBookmark(item?.id)}/> */}
                                                        <div className='recent-div-action'>
                                                            {item.is_user_bookmarked ? (
                                                                <IoBookmark
                                                                    className='workspaces-user-bookmarked-bg workspaces-user-bookmarked-hw'
                                                                    onClick={() => {
                                                                        if (
                                                                            !item?.is_restricted
                                                                        ) {
                                                                            handleToggleBookmark(
                                                                                item.id
                                                                            );
                                                                        } else {
                                                                            setModal2Open(
                                                                                true
                                                                            );
                                                                        }
                                                                    }}
                                                                />
                                                            ) : (
                                                                <IoBookmarkOutline
                                                                    className='workspaces-user-bookmarked-hw'
                                                                    onClick={() => {
                                                                        if (
                                                                            !item?.is_restricted
                                                                        ) {
                                                                            handleToggleBookmark(
                                                                                item.id
                                                                            );
                                                                        } else {
                                                                            setModal2Open(
                                                                                true
                                                                            );
                                                                        }
                                                                    }}
                                                                />
                                                            )}
                                                        </div>
                                                        <div className='recent-div-action'>
                                                            <div
                                                                className='recent-div-action-container'
                                                                onMouseEnter={() =>
                                                                    handleToggleAction(
                                                                        item.id
                                                                    )
                                                                }
                                                                onMouseLeave={() =>
                                                                    handleToggleAction(
                                                                        item.id
                                                                    )
                                                                }>
                                                                <HiOutlineDotsVertical />

                                                                <div
                                                                    className={`dropup-form-content recent-form-header-availibility ${
                                                                        itemToggleState[
                                                                            item
                                                                                .id
                                                                        ]
                                                                            ? 'recent-droup-down-avail-details'
                                                                            : ''
                                                                    }`}>
                                                                    <div className='form-header-text'>
                                                                        <span
                                                                            className='form-header-notifications-text'
                                                                            onClick={() => {
                                                                                if (
                                                                                    !item?.is_restricted
                                                                                ) {
                                                                                    handleOnEdit(
                                                                                        item?.id
                                                                                    );
                                                                                } else {
                                                                                    if (
                                                                                        JSON.parse(
                                                                                            localStorage.getItem(
                                                                                                'userDetails'
                                                                                            )
                                                                                        )
                                                                                            ?.id ===
                                                                                        item?.created_by
                                                                                    ) {
                                                                                        handleOnEdit(
                                                                                            item?.id
                                                                                        );
                                                                                    } else {
                                                                                        setQuickActionCreatedByName(
                                                                                            item?.created_by_name
                                                                                        );
                                                                                        setModal2Open(
                                                                                            true
                                                                                        );
                                                                                    }
                                                                                }
                                                                            }}>
                                                                            Edit
                                                                        </span>
                                                                    </div>
                                                                    <div className='form-separator-header'></div>
                                                                    <div
                                                                        className='form-header-text'
                                                                        onClick={() => {
                                                                            if (
                                                                                !item?.is_restricted
                                                                            ) {
                                                                                handleDelete(
                                                                                    item?.id
                                                                                );
                                                                            } else {
                                                                                if (
                                                                                    JSON.parse(
                                                                                        localStorage.getItem(
                                                                                            'userDetails'
                                                                                        )
                                                                                    )
                                                                                        ?.id ===
                                                                                    item?.created_by
                                                                                ) {
                                                                                    handleDelete(
                                                                                        item?.id
                                                                                    );
                                                                                } else {
                                                                                    setQuickActionCreatedByName(
                                                                                        item?.created_by_name
                                                                                    );
                                                                                    setModal2Open(
                                                                                        true
                                                                                    );
                                                                                }
                                                                            }
                                                                        }}>
                                                                        <span className='form-header-notifications-text form-text-color'>
                                                                            Delete
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p className='curve-para1-folder'>
                                                        {item.name}
                                                    </p>
                                                    <p
                                                        className='curve-para2-folder'
                                                        onClick={() => {
                                                            if (
                                                                !item?.is_restricted
                                                            ) {
                                                                handleOnAction(
                                                                    item?.id
                                                                );
                                                            } else {
                                                                setModal2Open(
                                                                    true
                                                                );
                                                            }
                                                        }}>
                                                        Action
                                                    </p>
                                                    {/* <hr className='hr-tag-folder' /> */}
                                                </div>
                                            )
                                        )}
                                    </div>
                                    <div className='resources-pagination'>
                                        <Pagination
                                            current={currentPage}
                                            pageSize={
                                                workspaceQuickactionsListData?.per_page
                                            }
                                            total={
                                                workspaceQuickactionsListData?.total
                                            }
                                            onChange={handlePageChange}
                                        />
                                    </div>
                                </>
                            ) : (
                                <p style={{ textAlign: 'center' }}>
                                    <b>Data Not Found...</b>
                                </p>
                            )}
                        </Card>
                    </>
                )}
            </div>
            <Drawer
                placement='right'
                closable={false}
                onClose={StandardOverlay}
                open={isStandardOpen}
                key='right'
                width={'40%'}>
                <AddActionDrawer StandardOverlay={StandardOverlay} />
            </Drawer>
            <Modal
                title='Restricted Access'
                centered
                open={modal2Open}
                onOk={() => setModal2Open(false)}
                onCancel={() => setModal2Open(false)}>
                <p>
                    The reference data and prompt for this QuickAction has been
                    restricted and can not be viewed or edited.
                    {/* This QuickAction has been created by{' '}
                    <span style={{ fontWeight: '600' }}>
                        {quickActionCreatedByName}
                    </span>
                    . The view for reference data and prompt has been restricted
                    by the owner. For further details, please contact{' '}
                    {quickActionCreatedByName}. */}
                </p>
            </Modal>
            <Modal
                title='Restricted Access'
                centered
                open={permissionModalOpen}
                onOk={() => setPermissionModalOpen(false)}
                onCancel={() => setPermissionModalOpen(false)}>
                <p>You do not have permission to edit this QuickAction.</p>
            </Modal>
        </div>
    );
};

export default FolderAction;
